import { render, staticRenderFns } from "./TransferMoneyUserType.vue?vue&type=template&id=529cf0d4&"
import script from "./TransferMoneyUserType.vue?vue&type=script&lang=js&"
export * from "./TransferMoneyUserType.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoneyUserType.vue?vue&type=style&index=0&id=529cf0d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports